import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from "../../../hooks";
import dayjs from 'dayjs';
import {
  HistoryContainer,
  HistoryWrapper,
  HistoryDate,
  HistoryDateWrapper,
  HistoryText,
  NoConversationsWrapper,
  CardWrapper,
} from './HistoryTab.styled';
import SearchInput from './SearchInput';

const HistoryTab = observer(({ selectedAgent, onTabChange }) => {
  const { agentsWidgetHistoryStore } = useStore();
  const conversations = agentsWidgetHistoryStore.conversations;
  const [sortedConversations, setSortedConversations] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredConversations, setFilteredConversations] = useState([]);

  useEffect(() => {
    const updateSortedConversations = () => {
      if (!conversations) return [];
      
      const filtered = conversations
        .filter(item => item.agent_id === selectedAgent.id)
        .sort((a, b) => new Date(b.last_modified) - new Date(a.last_modified));
      
      setSortedConversations(filtered);
    };

    updateSortedConversations();
  }, [conversations, selectedAgent.id]);

  useEffect(() => {
    if (!searchTerm) {
      setFilteredConversations(sortedConversations);
      return;
    }

    const filtered = sortedConversations.filter(conversation => 
      conversation.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    setFilteredConversations(filtered);
  }, [sortedConversations, searchTerm]);

  const handleConversationClick = (conversationId) => {
    agentsWidgetHistoryStore.setSelectedConversationId(conversationId);
    agentsWidgetHistoryStore.fetchMessages(conversationId);
    agentsWidgetHistoryStore.setLastConversationID(conversationId);
    onTabChange(0);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  if (sortedConversations.length === 0) {
    return (
      <HistoryContainer>
        <NoConversationsWrapper>
          There are no conversations with this agent yet.
        </NoConversationsWrapper>
      </HistoryContainer>
    );
  }

  return (
    <HistoryContainer>

      <SearchInput
        value={searchTerm}
        onChange={handleSearchChange}
        placeholder="Search"
        iconHeight="auto"
        iconWidth="18px"
        height="48px"
      />
      <CardWrapper>
        {filteredConversations.length > 0 ? (
            filteredConversations.map((conversation) => (
                <HistoryWrapper
                    key={conversation.id}
                    onClick={() => handleConversationClick(conversation.id)}
                >
                  <HistoryText>{conversation.title}</HistoryText>
                  <HistoryDateWrapper>
                    <HistoryDate>
                      {dayjs(conversation.last_modified).format('MM-DD-YYYY HH:mm')}
                    </HistoryDate>
                  </HistoryDateWrapper>
                </HistoryWrapper>
            ))
        ) : (
            <NoConversationsWrapper>
              No results found for "{searchTerm}"
            </NoConversationsWrapper>
        )}
      </CardWrapper>
    </HistoryContainer>
  );
});

export default HistoryTab;